import React, { useState } from "react";
import { withTranslation } from "react-i18next";
import greenTick from "assets/images/greentick.svg";
import validateEmail from "utils/validateEmail";
import isEmpty from "lodash/isEmpty";

const GiftInputField = ({ t, onChangeFunc, className, type, placeholder, disabled, required, testId, label }) => {
  const [valid, setValid] = useState(false);

  const onChangeHandle = (event) => {
    switch (type) {
      case "email":
        setValid(validateEmail(event.target.value));
        break;
      case "password":
        setValid(event.target.value.length > 5);
        break;
      default:
        setValid(!isEmpty(event.target.value?.trim()));
        break;
    }
    onChangeFunc(event.target.value);
  };

  return (
    <div className={`giftcard__inputField ${className}`}>
      {label && (
        <p className="my-10">
          {label}
          {required && <sup className="giftcard__inputField__required"> *</sup>}
        </p>
      )}
      <input type={type} placeholder={placeholder} onChange={onChangeHandle} disabled={disabled} data-cy={testId}></input>
      {valid && <img className="green-tick" src={greenTick} alt="" />}
    </div>
  );
};

export default withTranslation()(GiftInputField);
